import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { RegisterModalComponent} from "./register/register-modal.component";
import { RegisterFormComponent } from './register/register-form.component';
import { EmailRegisteredValidator} from "./register/emailRegistered.validator";
import { PreregisterModalComponent} from "./preregister/preregister-modal.component";
import { PreregisterFormComponent } from './preregister/preregister-form.component';
import { EmailPreregisteredValidator } from "./preregister/emailPreregistered.validator";
import { LoginComponent } from './login/login.component';
import { ActivateComponent } from './activate/activate.component';
import { ModalComponent } from './modal/modal.component';
import { LostPasswordComponent } from './lost-password/lost-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import {PlatformRoutingModule} from "./platform-routing.module";
import {VerifyEmailComponent} from "./verify-email/verify-email.component";
import {ChooseRegistrationComponent} from "./choose-registration/choose-registration.component";


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PlatformRoutingModule
  ],
  declarations: [RegisterModalComponent, RegisterFormComponent, PreregisterModalComponent, PreregisterFormComponent,  LoginComponent, ActivateComponent, ModalComponent, LostPasswordComponent, ResetPasswordComponent, VerifyEmailComponent, ChooseRegistrationComponent],
  providers: [EmailRegisteredValidator, EmailPreregisteredValidator],
  exports: [RegisterModalComponent, RegisterFormComponent, PreregisterFormComponent, LoginComponent, ModalComponent]

})
export class PlatformModule { }
